import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '../../core/services/modal.service';

@Component({
	selector: 'app-membership-modal',
	templateUrl: './membership-modal.component.html',
	styleUrls: ['./membership-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class MembershipModalComponent {
	@Input() text;

	@Input() subText;

	@Input() modalId;

	@Input() maskClose;

	@Input() authorLink;

	@Input() learnMoreButton;

	@Input() buttonText;

	@Input() titleCode;

	@Input() code;

	@Input() url;

	@Input() userNotLogged;

	@Input() hideButtonText;

	@Output() confirmChoice = new EventEmitter();

	public success;

	constructor(
		private ms: ModalService,
		private router: Router,
	) { }

	upgrade() {
		if (this.url) {
			window.open(this.url, '_blank');
		}
		this.confirmChoice.emit(true);
		this.ms.close(this.modalId);
	}

	cancel() {
		if (this.modalId !== 'modal-promo' && this.authorLink) {
			this.router.navigate([`/author-dashboard/${this.authorLink}/home`]).then();
		}
		this.ms.close(this.modalId);
	}

	learnMore() {
		this.confirmChoice.emit(false);
		this.ms.close(this.modalId);
	}
}
